<div class="main-content">
  <div class="container-fluid">
    <h3>Application — {{ serviceLabel }}</h3>
    <p class="text-muted">Completa il form per applicare al servizio.</p>

    <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Acronimo Progetto *</label>
            <input type="text" class="form-control" formControlName="project_acronym">
          </div>
        </div>
        <div class="col-md-8">
          <div class="form-group">
            <label>Nome completo Progetto *</label>
            <input type="text" class="form-control" formControlName="full_project_name">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Funding Programme *</label>
            <input type="text" class="form-control" formControlName="funding_programme">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Grant Agreement</label>
            <input type="text" class="form-control" formControlName="grant_agreement">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Organizzazione *</label>
            <input type="text" class="form-control" formControlName="organisation">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Paese *</label>
            <input type="text" class="form-control" formControlName="country">
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Descrizione breve del progetto *</label>
        <textarea class="form-control" rows="4" formControlName="project_short_description"></textarea>
      </div>
      <div class="form-group">
        <label>Obiettivi di standardizzazione *</label>
        <textarea class="form-control" rows="4" formControlName="objectives_standardisation"></textarea>
      </div>
      <div class="form-group">
        <label>Perché state applicando? *</label>
        <textarea class="form-control" rows="4" formControlName="why_the_project_applying"></textarea>
      </div>
      <div class="form-group">
        <label>
          <input type="checkbox" formControlName="website_publication">
          Acconsento alla pubblicazione sul sito
        </label>
      </div>

      <button type="submit" class="btn btn-primary" [disabled]="form.invalid || submitting">
        <span *ngIf="submitting"><i class="fa fa-spinner fa-spin"></i> Invio...</span>
        <span *ngIf="!submitting">Invia Application</span>
      </button>
      <a routerLink="/my-applications" class="btn btn-default" style="margin-left: 8px">Annulla</a>
    </form>
  </div>
</div>
